<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Массово добавить квартиры</h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'block-details', params: { block_id: $route.params.block_id } }">← Назад к Квартирам</router-link>
    </div>

    <apartment-bulk-add-form :block="+$route.params.block_id" @after="handleAfter" />

  </div>
</template>

<script>
import apartmentBulkAddForm from '@/components/forms/apartment/ApartmentBulkAddForm'

export default {
  name: 'apartment-bulk-add',
  components: { apartmentBulkAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'block-details', params: { block_id: this.$route.params.block_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentBulkAdd.vue?4dbdb876